import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '@/components/Dashboard/DashboardPendings/PendingsCard';
import { getOverviewVisitEvents } from '@/store/slices/components/dashboard/service';
import GenericBarChart from '../../../Charts/GenericBarChart';
import ShowingsLegend from './ShowingsLegend';
import useFetchDashboard from '@/components/Dashboard/customHooks/useFetchDashboard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import CalendarIcon from '@/public/images/dashboard/calendar.svg';
import { AGENT } from '@/components/FilterBar/constants/filtersConstants';
import { useTrackOverviewTab } from '@/components/Dashboard/customHooks/useTrackDashboard';

export default function Showings() {
  const dispatch = useDispatch();
  const { showings } = useSelector((state) => state.DashboardSlice);
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const track = useTrackOverviewTab();

  const { loading, hasFetched, labels, datasets, empty } = showings;
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');

  useFetchOnViewport(
    (query) => {
      dispatch(getOverviewVisitEvents(query));
    },
    [],
    { hasFetched }
  );

  const getBaseUrl = () => {
    let url = `${tokkoBrokerHost}/schedule/full_calendar?event_type=${showings.event_type_ids}`;

    if (
      selectedIds.some((el) => el.filter_type === AGENT) &&
      selectedIds.length === 1
    ) {
      url += `&agent=${selectedIds[0]}`;
    }

    if (selectedIds.length === 0) {
      url += '&agent=all';
    }

    return url;
  };

  const handleClickBarChart = (monthId) => {
    let url = getBaseUrl();
    url += `&month=${monthId}`;

    window.open(url, '_blank');
  };

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={!empty && getBaseUrl()}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.visits(element)}
      >
        {Trans(translations, 'Visits')}
      </PendingCard.Header>
      {empty ? (
        <DashboardEmptyStateCard
          icon={CalendarIcon}
          title={Trans(
            translations,
            'HereYouWillSeeTheNumberOfPendingAndCompletedVisits'
          )}
          description={Trans(translations, 'EachVisitIsKeyToClosingNewDeals')}
          buttonText={Trans(translations, 'GoToVisitsPanel')}
          onButtonClick={() => window.open(`/properties/visit`, '_blank')}
        />
      ) : (
        <>
          <ShowingsLegend />
          <GenericBarChart
            labels={labels}
            datasets={datasets}
            stacked
            onBarClick={
              selectedIds.length > 1
                ? null
                : ({ label }) => handleClickBarChart(label.monthId)
            }
          />
        </>
      )}
    </PendingCard>
  );
}
